import { FC } from 'react';

import { INSIGHTS_CARD_TEST_IDS } from '../../../constants/data-testids';
import { Card } from '../../atoms';
import { CardContent } from '../../atoms/Card/Card';
import { Skeleton } from '../../atoms/Skeleton/Skeleton';

export const InsightsCardSkeleton: FC = () => {
  return (
    <Card data-testid={INSIGHTS_CARD_TEST_IDS.SKELETON} className="rounded-[12px] p-4">
      <CardContent>
        <div className="min-h-[19px] flex items-center justify-between gap-3 mb-[31px]">
          <Skeleton className="h-[14px] w-[296px]" />
          <div className="flex items-center gap-2">
            <Skeleton className="h-[14px] w-[60px]" />
            <Skeleton className="h-[14px] w-[28px]" />
          </div>
        </div>
        <div className="min-h-[22px] flex items-center justify-between gap-3">
          <Skeleton className="h-[14px] w-[143px]" />
          <Skeleton className="h-[14px] w-[60px]" />
        </div>
      </CardContent>
    </Card>
  );
};
